import React, { useState } from 'react';
import { VscGame } from 'react-icons/vsc';
import { ReactComponent as PatternLeft } from './img/pattern-left.svg';
import { ReactComponent as PatternRight } from './img/pattern-right.svg';
import doneMedal from '@/assets/images/doneMedal.svg';
import { WeekChallengeModal } from '../week-challenge-modal';
import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';
import {
  ChallengeCard as ChallCard,
  ChallengeCardBanner,
  ChallengeCardBannerIcon,
  ChallengeCardBannerText,
  ChallengeCardBody,
  ChallengeCardCategory,
  ChallengeCardFooter,
  ChallengeCardHat,
  ChallengeCardIcon,
  ChallengeCardMedalDone,
  ChallengeCardName,
  ChallengeCardText,
  ChallengeCardTitle
} from '@/components/custom/challenge';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Button, ButtonIcon } from '@/components/ui/button';

export function WeekChallengeCard({ challenge }) {
  const { setCurrentChallenge, setCurrentStep, setRightAnswers, setCurrentRound, setStart, setGeneralCount, setShowQuestionCountDown, setQuestionCountDownTimer } = useWeeklyChallenge();
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setGeneralCount(0);
    setShowModal(false);
    setRightAnswers(0);
    setCurrentRound(1);
    setStart(false);
    setShowQuestionCountDown(false);
    setQuestionCountDownTimer(5);
    setTimeout(() => setCurrentStep(1), 300);
  };

  const handleStart = async () => {
    setCurrentChallenge(challenge);
    setShowModal(true);
  };

  return (
    <ChallCard done={challenge?.done}>
      <ChallengeCardMedalDone
        show={challenge?.done}
        src={doneMedal}
        alt="concluído"
      />

      <ChallengeCardHat>{challenge?.taxonomy?.name}</ChallengeCardHat>

      <AvatarWrapper
        size="lg"
        src={challenge?.image}
        text={challenge?.user?.name}
        className="mx-auto"
      />

      <ChallengeCardBody>
        <ChallengeCardCategory>
          <ChallengeCardIcon square>
            <VscGame />
          </ChallengeCardIcon>
        </ChallengeCardCategory>

        <ChallengeCardText>
          <ChallengeCardTitle title={challenge?.title}>{challenge?.title}</ChallengeCardTitle>
          <ChallengeCardName title={challenge?.user?.name}>{challenge?.user?.name}</ChallengeCardName>
          <p
            className="truncate"
            title={challenge?.user?.institution?.regional?.name}
          >
            {challenge?.user?.institution?.regional?.name}
          </p>
        </ChallengeCardText>

        <ChallengeCardBanner>
          <ChallengeCardBannerIcon>
            <PatternLeft />
          </ChallengeCardBannerIcon>
          <ChallengeCardBannerText title={`Ganhe ${challenge?.point} Pontos`}>Ganhe {challenge?.point} Pontos</ChallengeCardBannerText>
          <ChallengeCardBannerIcon>
            <PatternRight />
          </ChallengeCardBannerIcon>
        </ChallengeCardBanner>
      </ChallengeCardBody>

      <ChallengeCardFooter>
        {!challenge?.done ? (
          <Button
            variant="primary-light"
            size="sm"
            border
            fullWidth
            onClick={handleStart}
          >
            <ButtonIcon>
              <VscGame />
            </ButtonIcon>
            Começar desafio
          </Button>
        ) : (
          <Button
            variant="success"
            size="sm"
            fullWidth
          >
            Desafio concluído
          </Button>
        )}
      </ChallengeCardFooter>

      <WeekChallengeModal
        show={showModal}
        onClose={handleCloseModal}
      />
    </ChallCard>
  );
}
